<template>
  <v-container fill-height>
    <v-row justify="center" align="center">
      <v-col>
        <v-card
          class="mx-auto"
          max-width="344"
          outlined
          :color="colorFondo500"
          :style="'border: 3px solid grey;'"
        >
          <v-card-text>
            <v-row>
              <v-img
                src="../assets/logo_ebike.png"
                contain
                max-height="100"
                min-height="100"
              >
              </v-img>
            </v-row>
            <v-text-field
              v-model="name"
              class="mx-4 mt-12"
              label="Nombre"
              name="name"
              type="text"
              outlined
              dense
              :dark = dark
              autocomplete="off"
            >
            </v-text-field>

            <v-text-field
              id="password"
              v-model="password"
              class="mx-4"
              :dark = dark
              label="Contraseña"
              name="Contraseña"
              outlined
              dense
              type="password"
              @keydown.enter="_login"
            >
            </v-text-field>
          </v-card-text>

          <v-card-actions>
            <v-spacer />

            <v-chip
              label
              class="mb-4 px-10"
              style="width: 180px"
              link
              :color="colorEBikeAccent1"
              @click="_login"
            >
           
             
              <h5 class="ml-3" v-if="loading" v-bind:style="{ color: 'white' }">
                ACCEDIENDO...
              </h5>
              <h5 class="ml-5" v-else v-bind:style="{ color: 'white' }">ACCEDER</h5>
            
           

              
           

            </v-chip>
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  data: () => ({
    show: false,
    name: "",
    password: "",
  }),

  computed: {
    ...mapState([
      "loading",
      "drawer",
      "dark",

      "colorEBikeAccent1",
      "colorEBikeBarraFormulario",

      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
  },

  mounted() {
    //this.name = 'admin';
    //this.password = 'Abc2468*';
    //this._login();
  },

  methods: {
    ...mapActions("auth", ["login"]),
    ...mapMutations(["setDrawer"]),

    async _login() {
      await this.login([this.name, this.password]);
      if (!this.error && this.user != null) {
        this.setDrawer(true);
        this.$router.push("/Calendario");
      }
    },
  },
};
</script>

<style scoped>
.bottom-gradient {
  background-image: linear-gradient(
    to top,
    rgba(33, 34, 38, 1) 0%,
    transparent 80px
  );
}
</style>
